import gqlClient from "../../dependencies/gqlClient";
import type { ArrayElement } from "../../types";
import CancelAvailabilitySearchMutation, {
  type QueryResult,
  type QueryVariables,
} from "../mutations/cancelAvailabilitySearch";

export type CancelAvailabilitySearchParams = QueryVariables;

export default async function cancelAvailabilitySearch(
  variables: CancelAvailabilitySearchParams,
  abortSignal?: AbortSignal,
) {
  const result = await gqlClient({
    query: CancelAvailabilitySearchMutation,
    variables,
    abortSignal,
  });

  const cleanStatuses = (result.cancelAvailabilitySearch || []).filter(
    (
      availability,
    ): availability is NonNullable<
      ArrayElement<NonNullable<QueryResult["cancelAvailabilitySearch"]>>
    > => availability !== null,
  );

  return cleanStatuses;
}
